<template>
  <b-form-group
    :label="$t('fields.description')"
    label-for="description"
  >
    <b-form-textarea
      id="description"
      v-model="dataItem.description"
      :placeholder="$t('projects.form.descriptionPlaceholder')"
      rows="4"
      max-rows="8"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormTextarea,
} from 'bootstrap-vue'

export default {
  name: 'ProjectsDescriptionCard',
  components: {
    BFormGroup,
    BFormTextarea,
  },
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
  },
}
</script>
